import axios from "axios";
import Helpers from '@/modules/Helpers'

if(process.env.NODE_ENV === 'development'){
    let url = Helpers.getCookie('axios_url_'+process.env.NODE_ENV);
    if( typeof url === 'undefined'){
        Helpers.setCookie('axios_url_'+process.env.NODE_ENV, 'https://ad8.kredit24.kz/api', {
            expires: (60 * 60 * 24 * 365),
            domain: window.location.hostname,
            path: '/'
        });
    }
    axios.defaults.baseURL = Helpers.getCookie('axios_url_'+process.env.NODE_ENV);
}else{
    let url = Helpers.getCookie('axios_url_'+process.env.NODE_ENV);
    if( typeof url === 'undefined'){
        Helpers.setCookie('axios_url_'+process.env.NODE_ENV, 'https://admin.micro.kz/api', {
            expires: (60 * 60 * 24 * 365),
            domain: window.location.hostname,
            path: '/'
        });
    }
    axios.defaults.baseURL = Helpers.getCookie('axios_url_'+process.env.NODE_ENV);
}


// 3/api";
axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";

export default axios;
